import useMobile from "../../hooks/useMobile";

export default function SubmitSelection({ isLoading = false, onClick }) {
  const isMobile = useMobile();

  return (
    <button
      onClick={(e) => onClick(e)}
      // type="submit"
      className={`btn-primary size-m border-radius-s text-m ${
        isMobile ? "selections-centered" : ""
      }`}
      disabled={isLoading}
    >
      Подобрать
    </button>
  );
}
